// Potree is bundled as a standalone Rollup/UMD build (public/libs/potree/potree.js), separate
// from the main app's Vite bundle, so it can't import the app's TypeScript sources directly.
// Reads the ID token straight from the `oidc.user:...` localStorage key that oidc-client-ts
// writes to (see OidcConfig's userStore) - the one thing both bundles share. Duplicated from
// src/utils/auth/CurrentToken.ts; keep both in sync.
const OIDC_USER_STORAGE_PREFIX = 'oidc.user:';

export function getCurrentIdToken() {
    try {
        const key = Object.keys(window.localStorage).find((k) => k.startsWith(OIDC_USER_STORAGE_PREFIX));
        if (!key) return null;
        const raw = window.localStorage.getItem(key);
        if (!raw) return null;
        return JSON.parse(raw).id_token ?? null;
    } catch {
        return null;
    }
}
